<template>
  <div id="app">          
    <component :is="layout">      
      <RouterView />
    </component>    
  </div>
</template>

<script>
import axios from 'axios'
import RouterView from '@/view/RouterView.vue'
import { localize } from 'vee-validate';

const default_layout = "default-layout";


localize({
  
  en: {
    messages: {
      required: 'required',
      email: 'Not valid e-mail address',
      acceptConditions: "Privacy Policy required",
      fileFormat: 'Not valid file format',
      fileSize: 'The file size is too big (max 2Mb)',
      minSearch: "Min 3 characters"
    }
  },
  hu: {
    messages: {
      required: 'Kötelező megadni.',
      email: 'Az e-mail mező csak érvényes e-mail címet tartalmazhat.',
      acceptConditions: "Általános Adatvédelmi Rendelet elfogadása kötelező",
      fileFormat: 'Nem megfelelő file formátum',
      fileSize: "Túl nagy méretű a fájl, max 2Mb",
      minSearch: "Minimum 3 karakter"
    }
  },
  ru: {
    messages: {
      required: 'необходимые',
      email: 'Поле электронной почты может содержать только действительный адрес электронной почты.',
      acceptConditions: "Принятие Общих правил защиты данных является обязательным",
      fileFormat: 'Неверный формат файла',
      fileSize: 'Файл слишком большой, максимум 2 МБ',
      minSearch: "Не менее 3 символов"
    }
  },
});

export default { 
  data(){
    return{
      languages: [
        {
          id: '1',
          name: 'hu'
        },
        {
          id: '2',
          name: 'en'
        },
        {
          id: '3',
          name: 'ru'
        },
      ],      
      base_url: process.env.VUE_APP_BASE_URL
    }
  }, 
  components:{
    RouterView
  },   
  computed: {
    layout(){
      return ( this.$route.meta.layout || default_layout )
    }  
  },  
  watch:{
    $route:function(){
        this.deleteMetaTags()       ;
          document.getElementById('app').scrollTop  =0
           this.GTtrack('Navigation','routechange','empty');
    }
  },
  
  created(){       
    
    localize(this.currentLangName())     
    
    setTimeout(()=>{
      window.scrollTo(0, 0);
    })    
    this.setRouteLang()        

    this.$store.dispatch("setWebsiteLangFile");   
    this.$store.dispatch("setLanguages");
    this.$store.dispatch("setProducts_category"); 
    this.$store.dispatch("setRecipes_category");  
    this.$store.dispatch("set_Information_to_category");
    this.$store.dispatch("setNews_category");    
    console.log(window.location);
    const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('cache') == 'save')
      {
        
        setTimeout(function(){
          console.log('save');
          var meta = '';
          var page = document.getElementById('app').outerHTML;

          for (var i = 0; i < document.getElementsByTagName('meta').length; i++)
          {
            meta += document.getElementsByTagName('meta')[i].outerHTML;
            console.log(meta);
          }
          axios.post(process.env.VUE_APP_BIFROST_API_URL + '/page_cache?token='+urlParams.get('token'),{
               url: window.location.pathname,
               page: page,
               meta: meta
          })
        },1000);
      }
  }, 
 
  mounted(){    
      //meta lang 

      console.log(this.$route.query.published_date);
      if (window.location.href.indexOf('published_date=0') > -1)
      {
        this.$store.state.needPD = false;
        console.log(this.$store.state.needPD);
      }
      if ( this.$store.getters.getSelectedLang.name != null) {
          let metaLang = document.createElement('meta')
          metaLang.name = "language"
          metaLang.content = this.$store.getters.getSelectedLang.name.toLowerCase()
          document.getElementsByTagName('head')[0].appendChild(metaLang);
      }
    
      //meta site name      
      let metaOgSiteName = document.createElement('meta')
      metaOgSiteName.setAttribute('property', 'og:site_name')
      metaOgSiteName.content = 'Univer'
      document.getElementsByTagName('head')[0].appendChild(metaOgSiteName);
  },
  methods:{
    setRouteLang(){    
      // if an url was copied, set the selected lang in the store

      let _this = this        
      let urlHref = window.location.pathname
      let urlPath = urlHref.slice(_this.base_url.length - 1)
      let urlLang = urlPath.split('/')[1] 
      let urlArray = urlPath.split('/')       
      let storeSelectedLang = this.$store.getters.getSelectedLang                          

      if (storeSelectedLang.name == null && urlArray.length > 1 && urlLang != "") {         
        let selecUrlLang = {}  
        
        selecUrlLang = this.languages.find (item => item.name.toLowerCase() == urlLang.toLowerCase())

        if (selecUrlLang != undefined){
          this.$store.dispatch("setLang", {lang: selecUrlLang} );        
        }
                
      }
    },   
  } 
}
</script>